import { render } from "./ProjectAboutView.vue?vue&type=template&id=9d2eb4fa&scoped=true"
import script from "./ProjectAboutView.vue?vue&type=script&lang=js"
export * from "./ProjectAboutView.vue?vue&type=script&lang=js"

import "./ProjectAboutView.vue?vue&type=style&index=0&id=9d2eb4fa&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/coipor/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2eb4fa"]])

export default __exports__